import { animations } from './Animations/Animations.js';
import { fontStyles, fonts } from './Fonts/Fonts.js';
import { globals } from './Globals/Globals.js';
import { layout, spacing } from './Spacing/Spacing.js';
import { screen } from './Screen/Screen.js';
import { icons } from './Icons/Icons.js';
import { payoffColors } from './PayoffColors/PayoffColors.js';
import { colors } from './Colors/Colors.js';

const meta = {
  animations,
  colors,
  fontStyles,
  fonts,
  globals,
  layout,
  screen,
  icons,
  payoffColors,
  spacing
};
var index = {
  meta
};

export { index as default, meta };
//# sourceMappingURL=index.js.map
